export default {"src":"/_next/static/media/apple-store.0bfecd2a.svg","height":41,"width":120,"blurWidth":0,"blurHeight":0};